/*
  axios 接口封装 没有传token 没有loading
*/
import axios from 'axios';
import Vue from 'vue';
import { Loading, Message, MessageBox } from 'element-ui';
import route from '../router/index';
Vue.prototype.$message = Message;
// import qs from 'qs'
// 创建一个axios实例
const service = axios.create({
  timeout: 120000 * 10 // request timeout
});

// 添加请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做某事，比如说 设置token
    // config.headers['token'] = 'token';
    // config.headers['Content-Type'] = 'application/json';
    // if (config.platFlag == 'notoken') {
    // } else {
    if (localStorage.getItem('token') != 'undefined' && localStorage.getItem('token') != null) {
      config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
      config.headers['clientType'] = 'PC';
    }
    // }
    if (localStorage.getItem('applicationType') == 10) {
      var info = JSON.parse(localStorage.getItem('itemInfo'));
      config.headers['applicationDeptId'] = info.applicationDeptId;
      config.headers['applicationId'] = info.applicationId;
      config.headers['livestockType'] = info.livestockType;
    }
    return config;
  },
  error => {
    // 请求错误时做些事
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    // 如果返回的状态不是200 就主动报错
    //
    // console.log(res.code)
    if (res.state != 200 && res.code != 0 && res.code != 1 && res.code != 400 && res.status != 200) {
      return Promise.reject(res);
    }
    return response;
  },
  error => {
    const res = error.response.status;
    // if (res.code == 1 && res.msg == '你的登录信息已失效！请重新登录！') {
    //   localStorage.removeItem('token');
    //   localStorage.removeItem('userInfo');
    //   route.replace({ path: '/home', query: { name: 'loginout' } });
    // }
    if (res == 424 || res == 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('zizhouuserInfo');
      localStorage.removeItem('userInfo');
      route.replace({ path: '/home', query: { name: 'loginout' } });
      location.reload();
    }
    if (res * 1 > 500) {
      Message.warning('服务器正在维护,请稍后再试！');
    }

    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/apiLogin.js